const t = {
  name: "BatteryWrong",
  dimensions: { width: 40, height: 22 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 22" style="enable-background:new 0 0 40 22;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.5,9.6l2.3-2.3l1.4,1.4L18.9,11l2.3,2.3l-1.4,1.4l-2.3-2.3l-2.3,2.3l-1.4-1.4l2.3-2.3l-2.3-2.3l1.4-1.4
			L17.5,9.6z"/>
		<path class="st0" d="M35,0H0v22h35v-5h5V5h-5V0z M38,7v8h-3V7H38z M33,2v18H2V2H33z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as BatteryWrong
};
